module.exports = "<p>\r\n  text-help works!\r\n</p>\r\n"